<template>
  <div class="contact-page company-landing">
    <div class="landing-page-edit-panel"
         v-if="isGM()">
      <div class="wrapper" :class="[{ 'active': landingPanel }]">
        <div class="landing-page-edit-settings" @click.prevent="landingPanel = !landingPanel"></div>
        <div v-if="editHistory === false">
          <div class="action-btn"
               @click.prevent="pageMetaEdit = true">Edit page meta</div>
          <div class="action-btn"
               v-if="pageEditMode === false"
               @click.prevent="pageEditSwitch()">Edit page content</div>
          <div class="action-btn"
               @click.prevent="activateEditHistory()">Page edit history</div>
        </div>
        <div v-if="editHistory === true">
          <div class="form-group">
            <div class="form-element">
              <label for="page-versions" class="form-label color-2-63">Page save history</label>
              <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                        :searchable = false
                        @input="changeLandingPage($event)"
                        :options="getPageVersionsForSelect()"
                        data-lpignore="true"
                        id="page-versions" />
            </div>
          </div>
        </div>
        <div class="action-btn-bottom">
          <div class="action-btn action-btn-save"
               v-if="pageEditMode === true"
               @click.prevent="updateLandingPage()">Save</div>
          <div class="action-btn action-btn-discard"
               @click.prevent="discardPageEdit()">Discard</div>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="landing-page-wrapper hero-section no-padding-top contact-page-hero"
           v-show="!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())">
        <div class="landing-page-content">
          <div class="toggle-section-visibility"
               v-if="pageEditMode && isGM()">
            <input type="checkbox"
                   class="form-control__checkbox"
                   id="showHero"
                   v-model="content.heroSection.hideSection" />
            <label :for="'showHero'">Hide this section</label>
          </div>
          <div class="flex-section">
            <div class="left-content">
              <div class="hero-title">
                <h1 class="content color-2-100"
                    v-html="content.heroSection.title"
                    v-if="!pageEditMode">
                </h1>
                <textarea class="content color-2-100"
                          v-if="pageEditMode && isGM()"
                          data-gramm_editor="false"
                          placeholder="Section title"
                          data-lpignore="true"
                          rows="1"
                          v-model="content.heroSection.title"
                          v-on:keydown="autoSize($event)"></textarea>
              </div>
              <div class="hero-description">
                <p class="content color-2-100"
                   v-html="content.heroSection.description"
                   v-if="!pageEditMode">
                </p>
                <textarea class="content color-2-100"
                          v-if="pageEditMode && isGM()"
                          data-gramm_editor="false"
                          placeholder="Section description"
                          data-lpignore="true"
                          rows="1"
                          v-model="content.heroSection.description"
                          v-on:keydown="autoSize($event)"></textarea>
              </div>
              <div class="clearfix"></div>
              <div class="landing-page-contact-data">
                <div class="address">
                  <h2 class="color-1-100">
                    Address
                  </h2>
                  <p class="contact-info color-2-77"
                     v-if="!pageEditMode"
                     v-html="this.$options.filters.nl2br(content.contactsSection.address)"></p>
                  <textarea class="contact-info color-2-77"
                            v-if="pageEditMode && isGM()"
                            data-gramm_editor="false"
                            placeholder="Address"
                            data-lpignore="true"
                            rows="1"
                            v-model="content.contactsSection.address"
                            v-on:keydown="autoSize($event)"></textarea>
                  <p class="contact-info-additional color-2-77"
                     v-if="!pageEditMode"
                     v-html="this.$options.filters.nl2br(content.contactsSection.addressInfo)"></p>
                  <textarea class="contact-info-additional color-2-77"
                            v-if="pageEditMode && isGM()"
                            data-gramm_editor="false"
                            placeholder="Address info"
                            data-lpignore="true"
                            rows="1"
                            v-model="content.contactsSection.addressInfo"
                            v-on:keydown="autoSize($event)"></textarea>
                </div>
                <div class="contacts">
                  <div class="email">
                    <h2 class="color-1-100">
                      Email
                    </h2>
                    <a :href="'mailto:' + content.contactsSection.email"
                       class="contact-info color-2-77"
                       v-if="!pageEditMode"
                       target="_blank">{{ content.contactsSection.email }}</a>
                    <textarea class="contact-info color-2-77"
                              v-if="pageEditMode && isGM()"
                              data-gramm_editor="false"
                              placeholder="Email"
                              data-lpignore="true"
                              rows="1"
                              v-model="content.contactsSection.email"
                              v-on:keydown="autoSize($event)"></textarea>
                  </div>
                  <div class="phone">
                    <h2 class="color-1-100">
                      Telephone
                    </h2>
                    <a :href="'tel:' + content.contactsSection.phone"
                       class="contact-info color-2-77"
                       v-if="!pageEditMode"
                       target="_blank">{{ content.contactsSection.phone }}</a>
                    <textarea class="contact-info color-2-77"
                              v-if="pageEditMode && isGM()"
                              data-gramm_editor="false"
                              placeholder="Telephone"
                              data-lpignore="true"
                              rows="1"
                              v-model="content.contactsSection.phone"
                              v-on:keydown="autoSize($event)"></textarea>
                  </div>
                </div>
                <a href="#contact-form" class="landing-page-contact-data-scroll" @click.prevent="goToSection('contact-form')">
                  Or, send us your message and we'll get in touch with you.
                  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" class="svg-inline--fa fa-chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path fill="currentColor" d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"></path>
                  </svg>
                </a>
              </div>
            </div>
            <div class="right-content">
              <div class="hero-image">
                <div class="content"
                     :title="content.heroSection.altImage"
                     v-bind:style="{ backgroundImage: getImage(content.heroSection.image) }">
                  <input type="text"
                         placeholder="Alt image"
                         v-if="pageEditMode && isGM()"
                         class="landing-page-image-alt"
                         v-model="content.heroSection.altImage" />
                  <label :for="'hero-image-upload'"
                         v-if="pageEditMode && isGM()"
                         class="hero-upload"></label>
                  <input type="file"
                         v-if="pageEditMode && isGM()"
                         @change="onFileChange($event, content.heroSection, 'image')"
                         :id="'hero-image-upload'" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="landing-page-wrapper contact-summary landing-page-wrapper-gray" id="contact-form">
        <div class="landing-page-content">
          <div class="landing-page-section">
            <div class="landing-page-summary">
              <h2 class="landing-page-summary__title background-1-10-before color-1-100" v-if="!pageEditMode">
                {{ content.formSection.title }}
              </h2>
              <textarea class="landing-page-summary__title color-1-100"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section title"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.formSection.title"
                        v-on:keydown="autoSize($event)">{{ content.formSection.title }}</textarea>
              <div class="landing-page-contact-form">
                <form class="tcc-form" aria-describedby="formInfo" v-on:submit.prevent="submitContactForm()">
                  <div class="flex-section">
                    <div>
                      <div class="tcc-form-group">
                        <label for="name">First name*</label>
                        <input class="tcc-form-element tcc-form-element__input light"
                               :class="[{ 'border-1-50': formData.name.text !== '' || formData.name.focus, 'not-empty': formData.name.text !== '' || formData.name.focus, 'has-error': this.errors.has('First name') }]"
                               v-validate="'required'"
                               id="name"
                               @focus="formData.name.focus = true"
                               @blur="formData.name.focus = false"
                               v-model="formData.name.text"
                               placeholder="Type in here..."
                               name="First name"
                               type="text">
                        <span class="form-field-error" v-if="this.errors.has('First name')">{{ this.errors.first('First name') }}</span>
                      </div>
                      <div class="tcc-form-group">
                        <label for="surname">Last name*</label>
                        <input class="tcc-form-element tcc-form-element__input light"
                               :class="[{ 'border-1-50': formData.surname.text !== '' || formData.surname.focus, 'not-empty': formData.surname.text !== '' || formData.surname.focus, 'has-error': this.errors.has('Last name') }]"
                               v-validate="'required'"
                               id="surname"
                               @focus="formData.surname.focus = true"
                               @blur="formData.surname.focus = false"
                               v-model="formData.surname.text"
                               placeholder="Type in here..."
                               name="Last name"
                               type="text">
                        <span class="form-field-error" v-if="this.errors.has('Last name')">{{ this.errors.first('Last name') }}</span>
                      </div>
                      <div class="tcc-form-group">
                        <label for="job-title">Job title*</label>
                        <input class="tcc-form-element tcc-form-element__input light"
                               :class="[{ 'border-1-50': formData.jobTitle.text !== '' || formData.jobTitle.focus, 'not-empty': formData.jobTitle.text !== '' || formData.jobTitle.focus, 'has-error': this.errors.has('Job title') }]"
                               v-validate="'required'"
                               id="job-title"
                               @focus="formData.jobTitle.focus = true"
                               @blur="formData.jobTitle.focus = false"
                               v-model="formData.jobTitle.text"
                               placeholder="Type in here..."
                               name="Job title"
                               type="text">
                        <span class="form-field-error" v-if="this.errors.has('Job title')">{{ this.errors.first('Job title') }}</span>
                      </div>
                      <div class="tcc-form-group">
                        <label for="email">Email address*</label>
                        <input class="tcc-form-element tcc-form-element__input light"
                               :class="[{ 'border-1-50': formData.email.text !== '' || formData.email.focus, 'not-empty': formData.email.text !== '' || formData.email.focus, 'has-error': this.errors.has('Email address') }]"
                               v-validate="'required|email'"
                               id="email"
                               @focus="formData.email.focus = true"
                               @blur="formData.email.focus = false"
                               v-model="formData.email.text"
                               placeholder="Type in here..."
                               name="Email address"
                               type="email">
                        <span class="form-field-error" v-if="this.errors.has('Email address')">{{ this.errors.first('Email address') }}</span>
                      </div>
                      <div class="tcc-form-group">
                        <label for="phone">Telephone</label>
                        <input class="tcc-form-element tcc-form-element__input light"
                               :class="[{ 'border-1-50': formData.phone.text !== '' || formData.phone.focus, 'not-empty': formData.phone.text !== '' || formData.phone.focus }]"
                               id="phone"
                               @focus="formData.phone.focus = true"
                               @blur="formData.phone.focus = false"
                               v-model="formData.phone.text"
                               placeholder="Type in here..."
                               name="Telephone"
                               type="text">
                        <span class="form-field-error" v-if="this.errors.has('Telephone')">{{ this.errors.first('Telephone') }}</span>
                      </div>
                    </div>
                    <div>
                      <div class="tcc-form-group">
                        <label for="company">Company name*</label>
                        <input class="tcc-form-element tcc-form-element__input light"
                               :class="[{ 'border-1-50': formData.company.text !== '' || formData.company.focus, 'not-empty': formData.company.text !== '' || formData.company.focus, 'has-error': this.errors.has('Company name') }]"
                               v-validate="'required'"
                               id="company"
                               @focus="formData.company.focus = true"
                               @blur="formData.company.focus = false"
                               v-model="formData.company.text"
                               placeholder="Type in here..."
                               name="Company name"
                               type="text">
                        <span class="form-field-error" v-if="this.errors.has('Company name')">{{ this.errors.first('Company name') }}</span>
                      </div>
                      <div class="tcc-form-group">
                        <label for="industry">Industry</label>
                        <input class="tcc-form-element tcc-form-element__input light"
                               :class="[{ 'border-1-50': formData.industry.text !== '' || formData.industry.focus, 'not-empty': formData.industry.text !== '' || formData.industry.focus, 'has-error': this.errors.has('Industry') }]"
                               id="industry"
                               @focus="formData.industry.focus = true"
                               @blur="formData.industry.focus = false"
                               v-model="formData.industry.text"
                               placeholder="Type in here..."
                               name="Industry"
                               type="text">
                        <span class="form-field-error" v-if="this.errors.has('Industry')">{{ this.errors.first('Industry') }}</span>
                      </div>
                      <div class="tcc-form-group">
                        <label for="employees">Approximate number of employees</label>
                        <input class="tcc-form-element tcc-form-element__input light"
                               :class="[{ 'border-1-50': formData.employees.text !== '' || formData.employees.focus, 'not-empty': formData.employees.text !== '' || formData.employees.focus, 'has-error': this.errors.has('Approximate number of employees') }]"
                               id="employees"
                               @focus="formData.employees.focus = true"
                               @blur="formData.employees.focus = false"
                               v-model="formData.employees.text"
                               name="Approximate number of employees"
                               placeholder="Type in here..."
                               type="text">
                        <span class="form-field-error" v-if="this.errors.has('Approximate number of employees')">{{ this.errors.first('Approximate number of employees') }}</span>
                      </div>
                      <div class="tcc-form-group">
                        <label for="message">Your message*</label>
                        <textarea class="tcc-form-element tcc-form-element__textarea light"
                                  :class="[{ 'border-1-50': formData.message.text !== '' || formData.message.focus, 'not-empty': formData.message.text !== '' || formData.message.focus, 'has-error': this.errors.has('Your message') }]"
                                  id="message"
                                  v-validate="'required'"
                                  @focus="formData.message.focus = true"
                                  @blur="formData.message.focus = false"
                                  v-model="formData.message.text"
                                  placeholder="Type in here..."
                                  name="Your message"></textarea>
                        <span class="form-field-error" v-if="this.errors.has('Your message')">{{ this.errors.first('Your message') }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="landing-page-contact-form__subscribe">
                    <div class="tcc-form-group">
                      <input type="checkbox"
                             class="tcc-form-element tcc-form-element__checkbox"
                             aria-hidden="true"
                             tabindex="-1"
                             id="subscribe"
                             v-model="formData.subscribe" />
                      <label for="subscribe" tabindex="0">Subscribe me to the Clear Assured newsletter</label>
                      <p>
                        <strong>We value your privacy.</strong> We will only send you inclusion insights and best practice advice accompanied by news about our services and events. We will never sell or use the information you entrusted us with for any purpose other than staying in touch and keeping you informed. Read more about our commitment to privacy in our <router-link :to="{ name: 'privacy-policy' }">privacy policy</router-link>.
                      </p>
                    </div>
                  </div>
                  <div class="landing-page-contact-form__info">
                    <p id="formInfo">Fields marked with an asterisk (<span>*</span>) are mandatory.</p>
                  </div>
                  <div class="tcc-form-actions">
                    <button type="submit" class="tcc-form-action">
                      Submit message
                    </button>
                  </div>
                  <div class="tcc-form-message"
                       aria-live="assertive">
                    <div v-if="this.formStatus.submitting" class="visually-hidden">
                      Submitting
                    </div>
                    <template v-else>
                      <template v-if="formStatus.shown">
                        <h2 v-if="formStatus.title !== ''">
                          <template v-if="formStatus.success">
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" class="svg-inline--fa fa-circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                              <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"></path>
                            </svg>
                          </template>
                          <template v-else>
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-xmark" class="svg-inline--fa fa-circle-xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                              <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"></path>
                            </svg>
                          </template>
                          {{ formStatus.title }}
                        </h2>
                        <p v-if="formStatus.body !== ''">
                          {{ formStatus.body }}
                        </p>
                      </template>
                      <template v-else-if="this.errors.items && this.errors.items.length">
                        <h2>
                          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-exclamation" class="svg-inline--fa fa-circle-exclamation" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"></path>
                          </svg>
                          Some fields are missing.
                        </h2>
                        <p>Please fill in all the mandatory fields - they are marked with an asterisk. You should also see them in red and with a warning message showing under each field.</p>
                      </template>
                    </template>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-page-change-image" v-if="pageMetaEdit && isGM()">
      <div class="modal-inner" ref="metaEditPopup">
        <h2>Change page meta</h2>
        <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
        <div class="popup-footer-edit">
          <div>
            <div class="meta-description">
              <label for="meta-title">Title</label>
              <input id="meta-title"
                     placeholder="Page meta title"
                     v-model="metaData.title" />
            </div>
            <div class="meta-description">
              <label for="meta-description">Description</label>
              <textarea id="meta-description"
                        placeholder="Page meta description"
                        v-model="metaData.description">{{ metaData.description }}</textarea>
            </div>
          </div>
        </div>
        <div class="popup-actions">
          <a href="#" @click.prevent="closePopup()" class="discard">Discard</a>
          <a href="#" @click.prevent="updateMeta()" class="submit">Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'

export default {
  name: 'contact',
  data () {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: '',
        submitting: false
      },
      metaData: {
        title: '',
        description: ''
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: '',
          hideSection: false
        },
        contactsSection: {
          address: '',
          addressInfo: '',
          email: '',
          phone: ''
        },
        formSection: {
          title: ''
        }
      },
      formData: {
        name: {
          text: '',
          focus: false
        },
        surname: {
          text: '',
          focus: false
        },
        jobTitle: {
          text: '',
          focus: false
        },
        email: {
          text: '',
          focus: false
        },
        phone: {
          text: '',
          focus: false
        },
        company: {
          text: '',
          focus: false
        },
        industry: {
          text: '',
          focus: false
        },
        employees: {
          text: '',
          focus: false
        },
        message: {
          text: '',
          focus: false
        },
        subscribe: false
      },
      contactRequest: {
        shown: false,
        success: true,
        message: '',
        email: ''
      },
      windowWidth: window.innerWidth,
      serverValidation: {
        errors: []
      },
      disableAPI: false
    }
  },
  computed: {
    ...mapGetters([
      'getIsLoggedIn',
      'getUserRole',
      'selectedHightCont',
      'getSelectedFontSize'
    ])
  },
  methods: {
    ...mapActions([
      'redirect',
      'getRoles',
      'setFontSizeActive',
      'setColorPaletteActive'
    ]),
    submitContactForm () {
      if (this.disableAPI) return
      this.formStatus.submitting = true
      this.$validator.validateAll([
        'First name',
        'Last name',
        'Job title',
        'Telephone',
        'Your message',
        'Email address',
        'Company name',
        'Industry',
        'Approximate number of employees'
      ]).then((valid) => {
        if (!valid) {
          this.formStatus.submitting = false
          setTimeout(() => {
            this.scrollToTheMessage()
          }, 100)
          return
        }
        let body = {
          name: this.formData.name.text,
          surname: this.formData.surname.text,
          jobTitle: this.formData.jobTitle.text,
          email: this.formData.email.text,
          phone: this.formData.phone.text,
          company: this.formData.company.text,
          industry: this.formData.industry.text,
          employees: this.formData.employees.text,
          message: this.formData.message.text,
          subscribe: this.formData.subscribe
        }
        this.disableAPI = true
        this.$http.post(api.URLS.contactSubmit, body, api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          this.formStatus.shown = true
          this.formStatus.success = true
          this.formStatus.title = 'You have successfully submitted your message.'
          this.formStatus.body = 'Thank you for getting in touch. We usually reply to the contact form message in maximum 24 hours from when it was submitted to us. If your inquiry is urgent, please give us a call.'
          this.formData.name.text = ''
          this.formData.surname.text = ''
          this.formData.jobTitle.text = ''
          this.formData.email.text = ''
          this.formData.phone.text = ''
          this.formData.company.text = ''
          this.formData.industry.text = ''
          this.formData.employees.text = ''
          this.formData.message.text = ''
          this.formData.subscribe = false
          setTimeout(() => {
            this.scrollToTheMessage()
            this.errors.clear()
          }, 100)
          this.formStatus.submitting = false
        }).catch((err) => {
          this.formStatus.submitting = false
          this.serverValidation.errors = err
          this.disableAPI = false
          this.formStatus.shown = true
          this.formStatus.success = false
          this.formStatus.title = err.body.message || 'Your message was not submitted.'
          this.formStatus.body = 'It looks like there was an error and your message could not be sent. Please try again or give us a call and we\'ll have our support team help you.'
          setTimeout(() => {
            this.scrollToTheMessage()
          }, 100)
        })
      })
    },
    scrollToTheMessage () {
      let elem = document.querySelector('.tcc-form-message')
      if (elem) {
        elem.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
    },
    updateLandingPage () {
      if (this.disableAPI) return
      let body = JSON.stringify(this.content)
      let pageData = {
        slug: 'contact-page',
        body: body
      }
      this.disableAPI = true
      this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.getLandingPage()
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    updateMeta () {
      if (this.disableAPI) return
      let metaTitle = this.metaData.title
      let metaDescription = this.metaData.description
      let pageData = {
        title: metaTitle,
        slug: 'contact-page',
        description: metaDescription
      }
      this.disableAPI = true
      this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        document.location.reload()
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    getLandingPage (id) {
      if (this.disableAPI) return
      this.disableAPI = true
      let body = {
        slug: 'contact-page'
      }
      if (id) {
        body.id = id
      }
      this.$http.post(api.URLS.staticpage + '/contact-page', body, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        let pageData = JSON.parse(res.data.body)
        this.content = {...this.content, ...pageData}
        this.metaData.title = res.data.title
        this.metaData.description = res.data.description
        if (this.metaData.title && this.metaData.title !== '') {
          document.title = this.metaData.title + ' | Clear Assured'
        }
        this.addPageMeta('description', [{name: 'content', value: this.metaData.description}])
        this.content.title = this.metaData.title
        this.content.description = this.metaData.description
        if (id) {
          this.pageEditSwitch()
        } else {
          this.pageEditMode = false
        }
        this.$store.commit('setUserDimensions')
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname])
          window._paq.push(['setDocumentTitle', document.title])
          window._paq.push(['trackPageView'])
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    getPageVersions () {
      let self = this
      if (this.disableAPI) return
      this.disableAPI = true
      this.$http.get(api.URLS.staticpagechanges + '/contact-page', api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.pageVersions = []
        for (let index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          })
        }
        this.editHistory = true
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    activateEditHistory () {
      this.getPageVersions()
    },
    getPageVersionsForSelect () {
      return this.pageVersions
    },
    changeLandingPage (el) {
      this.getLandingPage(el.id)
    },
    convertDateTime (payload) {
      if (!payload) return
      let date = new Date(payload)
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let ampm = hours >= 12 ? 'PM' : 'AM'
      let newHours = hours % 12 ? hours % 12 : 12
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      let dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear
      let timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm
      return dateString + ' ' + timeString
    },
    addPageMeta (name, data) {
      let meta = document.createElement('meta')
      meta.name = name
      for (let index in data) {
        meta.setAttribute(data[index].name, data[index].value)
      }
      document.getElementsByTagName('head')[0].appendChild(meta)
    },
    discardChanges () {
      this.getLandingPage()
    },
    pageEditSwitch () {
      this.pageEditMode = true
      this.$nextTick(() => {
        this.autoSizeOnInit()
      })
    },
    discardPageEdit () {
      this.discardChanges()
      if (this.editHistory) {
        this.editHistory = false
      } else {
        this.landingPanel = false
      }
    },
    autoSize (el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0'
        el.target.style = 'height:' + el.target.scrollHeight + 'px'
      }, 0)
    },
    autoSizeOnInit () {
      let textAreas = document.getElementsByTagName('textarea')
      for (let i = 0; i < textAreas.length; i++) {
        let item = textAreas[i]
        setTimeout(function () {
          item.style = 'height:auto; padding:0'
          item.style = 'height:' + item.scrollHeight + 'px'
        }, 0)
      }
    },
    isGM () {
      let isLogged = this.getIsLoggedIn
      if (!isLogged) {
        return false
      }
      let userRole = this.getUserRole
      if (userRole === 'gm') {
        return true
      }
      return false
    },
    handleWindowResize (event) {
      this.windowWidth = event.currentTarget.innerWidth
    },
    getDeviceType (check) {
      let width = this.windowWidth
      let deviceName = ''
      if (width > 940) {
        deviceName = 'desktop'
      } else if (width > 640) {
        deviceName = 'tablet'
      } else {
        deviceName = 'mobile'
      }
      return check === deviceName
    },
    closePopup () {
      this.pageMetaEdit = false
    },
    getImage (payload) {
      if (!payload) {
        return ''
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')'
    },
    getImagePath () {
      return api.serverURL + '/uploads/images/content/'
    },
    isBase64 (payload) {
      return payload.indexOf('data:') !== -1
    },
    onFileChange (e, target, item) {
      var input = e.target
      let self = this
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader()
        reader.onload = function (e) {
          let fileName = input.files[0].name
          let extension = fileName.split('.').pop().toLowerCase()
          if (self.disableAPI) return
          let pageData = {
            file: e.target.result,
            extension: extension
          }
          self.disableAPI = true
          self.$http.post(api.URLS.uploadFile, pageData, api.headersAuthSettings).then((res) => {
            self.disableAPI = false
            target[item] = res.body
          }).catch((err) => {
            self.disableAPI = false
            console.log('err', err)
          })
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    goToSection (id) {
      let element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    },
    heroImageHeightFix () {
      let imageContainer = document.querySelector('.hero-section .right-content')
      let image = document.querySelector('.hero-section .hero-image')
      let header = document.querySelector('header')
      let maxHeight = window.innerHeight
      if (header) {
        maxHeight -= header.offsetHeight
      }
      if (imageContainer && image && (image.clientHeight < maxHeight || imageContainer.clientHeight < maxHeight)) {
        imageContainer.style.height = `${maxHeight}px`
        image.style.maxHeight = `${maxHeight}px`
      }
    }
  },
  created () {
    this.getLandingPage()
  },
  mounted () {
    this.setFontSizeActive()
    this.setColorPaletteActive()
    this.heroImageHeightFix()
    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('resize', this.heroImageHeightFix)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('resize', this.heroImageHeightFix)
  },
  watch: {}
}
</script>

<style src="@/assets/scss/main/homepage.scss" lang="scss" scoped></style>
<style src="@/assets/scss/main/landing-page.scss" lang="scss" scoped></style>
<style src="@/assets/scss/main/company-landing.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// Contact.vue?487b854a